import { render, staticRenderFns } from "./pipe-news.vue?vue&type=template&id=ce8b9c08&scoped=true"
import script from "./pipe-news.vue?vue&type=script&lang=js"
export * from "./pipe-news.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce8b9c08",
  null
  
)

export default component.exports